import { useMutation } from '@apollo/client';
import { gql } from '../graphql/generated/gql';
import { legacyUpdateQueryList } from '../utils/graphql/updateQueryList';

// eslint-disable-next-line slab-graphql/no-unused-fields
gql(`
  fragment useInviteMutation_invitation on Invitation {
    id
    name
    email
    avatar {
      thumb
      original
    }
    inviter {
      id
    }
    status
  }
`);

const INVITE_MUTATION = gql(/** @complexity 6 */ `
  mutation invite(
    $email: String!
    $name: String
    $favoriteIds: [ID!]
    $memberIds: [ID!]
    $source: InvitationSource
    $type: ProvisionType!
  ) {
    invite(
      email: $email
      name: $name
      favoriteIds: $favoriteIds
      memberIds: $memberIds
      source: $source
      type: $type
    ) {
      ...useInviteMutation_invitation
    }
  }
`);

const ORG_INVITATIONS_UPDATE_QUERY = gql(/** @complexity 8 */ `
  query orgInvitationsUpdate {
    currentSession {
      organization {
        id
        invitations {
          ...useInviteMutation_invitation
        }
      }
    }
  }
`);

const useInviteMutation = () => {
  const [invite] = useMutation(INVITE_MUTATION, {
    update: legacyUpdateQueryList(
      { query: ORG_INVITATIONS_UPDATE_QUERY },
      'currentSession.organization.invitations',
      'invite',
      true,
    ),
  });

  return invite;
};

export default useInviteMutation;
